import * as React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { validarToken } from "./herramientas/JWT";
import { Error400, Error401, Error403, Error404, Error500, Error503, } from "./pages";
import HomePage from "./HomePage.react";
import LogOut from "./Auth/LogOut";
import { UsuariosPage,  RolesPage, ProveedoresPage, DispositivosPage, LivePage, AlertasCctvPage } from "./pages";
/**
 * Usuario
 */
import { ProfilePage } from "./pages"
/**
 * Fin Gerenciador
 */
 import { LoginPage, SeguridadPage, RecuperarPasswordPage } from "./pages";
 /**
  * Fin seguridad
  */

//require ("./Temas/TablerDark.css");
require ("./Temas/TablerDefault.css");

var user= JSON.parse(sessionStorage.getItem("usuario"));
var currentTema= user ? JSON.parse( localStorage.getItem('skyonetema'+user.id) ): null;
var hoja = document.createElement('style')
if( currentTema ){
  if( currentTema.value ){
    hoja.innerHTML = currentTema.tema;
    document.body.appendChild(hoja);
  }  
}
const paginaspublicas= ['RECUPERAR_PASSWORD', 'LOGIN', 'ACTUALIZAR_PASSWORD'];
let ban= false;
for(let p of paginaspublicas){
 if( window.location.href.toUpperCase().includes(p) ){ ban= true;}
}
if( !ban ){ validarToken() }
type Props = {||};
function App(props: Props): React.Node {
  return (
    <div>
      <React.StrictMode>
        <Router>
          <Switch>
            <Route exact path="/"                     component={HomePage} />
            <Route exact path="/logout"               component={LogOut} />
            <Route exact path="/login"                component={LoginPage} />
            <Route exact path="/perfilusuario"        component={ ProfilePage } />
            <Route exact path="/roles"                component={RolesPage} />
            <Route exact path="/actualizar_password"  component={SeguridadPage} />
            <Route exact path="/recuperar_password"   component={RecuperarPasswordPage} />
            <Route exact path="/usuarios"             component={UsuariosPage} />
            <Route exact path="/proveedores"          component={ProveedoresPage} />
            <Route exact path="/dispositivos"         component={DispositivosPage} />
            <Route exact path="/live"                 component={LivePage} />
            <Route exact path="/alertas"              component={AlertasCctvPage} />            
            <Route exact path="/400"                  component={Error400} />
            <Route exact path="/401"                  component={Error401} />
            <Route exact path="/403"                  component={Error403} />
            <Route exact path="/404"                  component={Error404} />
            <Route exact path="/500"                  component={Error500} />
            <Route exact path="/503"                  component={Error503} />
            <Route component={Error404} />
          </Switch>
        </Router>
      </React.StrictMode>
    </div>
  );
}

export default App;
